import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';

export function useTestimonials({ active, featured, limit } = {}) {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(false);
      try {
        let query = supabase
          .from('testimonials')
          .select('*')
          .order('display_order', { ascending: true })
          .order('created_at', { ascending: false });

        if (active != null) query = query.eq('is_active', active);
        if (featured != null) query = query.eq('is_featured', featured);
        if (limit != null) query = query.limit(limit);

        const { data, error: qError } = await query;
        if (qError) throw qError;
        if (!cancelled) setTestimonials(data || []);
      } catch {
        if (!cancelled) {
          setTestimonials([]);
          setError(true);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [active, featured, limit]);

  return { testimonials, loading, error };
}
